var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellUsedInsepection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 151.844,
    height: 151.844,
    rx: 75.922,
    fill: "#EFF8F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3930_921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5039 62.2002H66.5791C66.0743 62.2002 65.6758 61.8017 65.6758 61.2969V55.2393C65.6758 54.7345 66.0743 54.3359 66.5791 54.3359H72.5039C73.0087 54.3359 73.4072 54.7345 73.4072 55.2393V61.2969C73.4072 61.8017 73.0087 62.2002 72.5039 62.2002Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2344 62.2002H79.3096C78.8048 62.2002 78.4062 61.8017 78.4062 61.2969V55.2393C78.4062 54.7345 78.8048 54.3359 79.3096 54.3359H85.2344C85.7392 54.3359 86.1377 54.7345 86.1377 55.2393V61.2969C86.1377 61.8017 85.7392 62.2002 85.2344 62.2002Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5039 75.0635H66.5791C66.0743 75.0635 65.6758 74.665 65.6758 74.1602V68.1026C65.6758 67.5977 66.0743 67.1992 66.5791 67.1992H72.5039C73.0087 67.1992 73.4072 67.5977 73.4072 68.1026V74.1602C73.4072 74.665 73.0087 75.0635 72.5039 75.0635Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2344 75.0635H79.3096C78.8048 75.0635 78.4062 74.665 78.4062 74.1602V68.1026C78.4062 67.5977 78.8048 67.1992 79.3096 67.1992H85.2344C85.7392 67.1992 86.1377 67.5977 86.1377 68.1026V74.1602C86.1377 74.665 85.7392 75.0635 85.2344 75.0635Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7806 108.11H55.7151C54.9712 108.11 54.3867 107.525 54.3867 106.782V46.8428C54.3867 45.2753 55.662 44 57.203 44H94.2662C95.8337 44 97.109 45.2753 97.109 46.8428V106.782C97.109 107.499 96.4979 108.11 95.7806 108.11ZM57.0436 105.453H94.4522V46.8428L57.203 46.6569L57.0436 105.453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2812 108.11H61.2151C60.4712 108.11 59.8867 107.526 59.8867 106.782V52.3428C59.8867 50.7753 61.162 49.5 62.7296 49.5H88.7668C90.3343 49.5 91.6096 50.7753 91.6096 52.3428V106.782C91.6096 107.499 90.9985 108.11 90.2812 108.11ZM62.5436 105.453H88.9528V52.3428L62.7296 52.1569L62.5436 105.453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9256 77.7941H87.9138C87.4356 76.7845 86.426 76.0938 85.2304 76.0938C83.6097 76.0938 82.2812 77.4222 82.2812 79.0429C82.2812 80.6635 83.6097 81.992 85.2304 81.992C86.426 81.992 87.4356 81.3012 87.9138 80.2916H91.9256C92.6164 80.2916 93.1744 79.7336 93.1744 79.0429C93.1744 78.3521 92.6164 77.7941 91.9256 77.7941Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.166 108.11H48.3284C47.5845 108.11 47 107.525 47 106.782C47 106.038 47.5845 105.453 48.3284 105.453H103.166C103.91 105.453 104.494 106.038 104.494 106.782C104.494 107.525 103.883 108.11 103.166 108.11Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3930_921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.4944,
    height: 64.11,
    fill: "white",
    transform: "translate(47 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellUsedInsepection);
export default __webpack_public_path__ + "static/media/SellUsedInsepection.6657850c.svg";
export { ForwardRef as ReactComponent };